export const generateHeaders = (jwt) => {
    const headers: {
    'Content-Type': string;
    'Authorization'?: string;
  } = {
      'Content-Type': 'application/json',
  };
    if (jwt) {
        headers.Authorization = `bearer ${jwt}`;
    }
    return headers;
};

export const youTubeParser = (url: string | undefined): string | false => {
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    const match = url?.match(regExp);
    return match && match[7].length === 11 ? match[7] : false;
};
